import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import {DateTimeHelper} from '../../../../helper/date-time.helper';
import { Employee } from '../../../../models/cloud/cloud.model';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';

@Component({
  selector: 'fi-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
  standalone: false,
})
export class UserCardComponent implements OnInit {
  @Input() user: Employee;
  @Input() isCloudUser: boolean;
  @Input() hideToggle: boolean;
  @Input() activated: boolean;
  @HostBinding('class.clickable') @Input() isClickable: boolean = true;
  @Output() openUserDetails = new EventEmitter<void>();
  @Output() openDeactivationDialog = new EventEmitter<void>();

  private static readonly roleText = new WeakMap<Employee, string>();

  constructor(public sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.scrollToTop();
  }

  scrollToTop(): void {
    if(window.innerWidth <= 768) {
      window.scrollTo(0, 0);
    }
  }

  get userRoles(): string {
    if (!this.user) {
      return '';
    }

    if (!UserCardComponent.roleText.has(this.user)) {
      const deduplicated = new Set(this.user?.Appplications?.filter((x: any) => x.Category).map((x: any) => `${x.Category}`) ?? []);
      UserCardComponent.roleText.set(this.user, [...deduplicated].join(', '));
    }

    return UserCardComponent.roleText.get(this.user);
  }

  get date(): string {
    return this.user?.User.LastActivity ? DateTimeHelper.getFormattedDate(this.user?.User.LastActivity).split(' - ')[0] : '';
  }

  openUserDetail(): void {
    this.openUserDetails.emit();
  }

  deactivateUser(): void {
    if (this.activated) {
      this.openDeactivationDialog.emit();
    }
  }
}
